export class AnimatedCreativeAdApi {
    constructor(_animatedCreative) {
        this._animatedCreative = _animatedCreative;
        console.debug('[AdApi] constructed');
    }
    play() {
        var _a;
        (_a = this._animatedCreative.animator) === null || _a === void 0 ? void 0 : _a.play();
    }
    pause() {
        var _a;
        (_a = this._animatedCreative.animator) === null || _a === void 0 ? void 0 : _a.pause();
    }
    stop() {
        var _a;
        (_a = this._animatedCreative.animator) === null || _a === void 0 ? void 0 : _a.stop();
    }
    seek(time) {
        var _a;
        (_a = this._animatedCreative.animator) === null || _a === void 0 ? void 0 : _a.seek(time);
    }
    mute(muted) {
        var _a;
        (_a = this._animatedCreative.renderer) === null || _a === void 0 ? void 0 : _a.mute_m(muted);
    }
    async renderDynamicProperty(dynamicData) {
        return this._animatedCreative.updateDynamicPropertyElement_m(dynamicData);
    }
}
